import { createAction } from 'redux-act';
// report-common
import { getReportActions } from '../../report-common';
//////////////////////////////////////////////////
const {
  selectItem,
  setReports,
  setUsedReport,
  setListLoading,
  setFilterProps,
  setInitialState,
  setReportPending,
  setTableTitleSort,
  getItemListRequest,
  getItemListSuccess,
  createReportRequest,
  updateReportRequest,
  setTableTitleFilter,
  setIgnorePromptStatus,
  resetListAndPagination,
  exportReportDataRequest,
  setInitialStateOmitReport,
  changeDefaultReportRequest,
  getAvailableReportsRequest,
} = getReportActions();

const setTruckGuid = createAction('setTruckGuid');
const setDriverGuid = createAction('setDriverGuid');
const getTruckListSuccess = createAction('getTruckListSuccess');
const toggleFuelCardDetails = createAction('toggleFuelCardDetails');
const updateFuelCardRequest = createAction('updateFuelCardRequest');
const createFuelCardRequest = createAction('createFuelCardRequest');
const deleteFuelCardsRequest = createAction('deleteFuelCardsRequest');
const deleteFuelCardsSuccess = createAction('deleteFuelCardsSuccess');
const sendToFinancialRequest = createAction('sendToFinancialRequest');
const assignDriverTruckRequest = createAction('assignDriverTruckRequest');
const visitFuelCardsOnFleetPage = createAction('visitFuelCardsOnFleetPage');
const receivedDriverListSuccess = createAction('receivedDriverListSuccess');
const updateTruckFuelCardRequest = createAction('updateTruckFuelCardRequest');
const setDriverAssignmentsTrucks = createAction('setDriverAssignmentsTrucks');
const updateDriverFuelCardRequest = createAction('updateDriverFuelCardRequest');
const toggleShowUnemployedDrivers = createAction('toggleShowUnemployedDrivers');
const setAdditionalSearchCriteria = createAction('setAdditionalSearchCriteria');
const getFuelCardTotalCountRequest = createAction('getFuelCardTotalCountRequest');
const getFuelCardTotalCountSuccess = createAction('getFuelCardTotalCountSuccess');
const getLinesByFuelCardGuidSuccess = createAction('getLinesByFuelCardGuidSuccess');
const toggleShowIsNotInServiceTrucks = createAction('toggleShowIsNotInServiceTrucks');

export {
  // report
  selectItem,
  setReports,
  setUsedReport,
  setListLoading,
  setFilterProps,
  setInitialState,
  setReportPending,
  setTableTitleSort,
  getItemListRequest,
  getItemListSuccess,
  updateReportRequest,
  createReportRequest,
  setTableTitleFilter,
  setIgnorePromptStatus,
  resetListAndPagination,
  exportReportDataRequest,
  setInitialStateOmitReport,
  changeDefaultReportRequest,
  getAvailableReportsRequest,
  // report
  setTruckGuid,
  setDriverGuid,
  getTruckListSuccess,
  toggleFuelCardDetails,
  updateFuelCardRequest,
  createFuelCardRequest,
  deleteFuelCardsRequest,
  deleteFuelCardsSuccess,
  sendToFinancialRequest,
  assignDriverTruckRequest,
  visitFuelCardsOnFleetPage,
  receivedDriverListSuccess,
  updateTruckFuelCardRequest,
  setDriverAssignmentsTrucks,
  updateDriverFuelCardRequest,
  toggleShowUnemployedDrivers,
  setAdditionalSearchCriteria,
  getLinesByFuelCardGuidSuccess,
  toggleShowIsNotInServiceTrucks,
};
